import {connect} from '@modifi/redux'
import {aCloseDialog} from '@modifi/plugin-dialogs'

import ResolveTaskDialog, {ResolveTaskDialogProps} from './ResolveTaskDialog'
import {
  aReset,
  aSubmit,
  selectUpdateErrorMessage,
  selectUpdateHasError,
  selectUpdatePending,
} from '../../store'

const mapStateToProps = (
  state: Record<string, any>
): Pick<ResolveTaskDialogProps, 'isUpdatePending' | 'hasUpdateError' | 'updateErrorMessage'> => ({
  isUpdatePending: selectUpdatePending(state),
  hasUpdateError: selectUpdateHasError(state),
  updateErrorMessage: selectUpdateErrorMessage(state),
})

const mapDispatchToProps = {
  submit: aSubmit,
  reset: aReset,
  discard: aCloseDialog,
}

export const DIALOG_NAME = 'tasks/resolve-task'
export default connect(mapStateToProps, mapDispatchToProps)(ResolveTaskDialog)
